export const INSTALLATION_GUIDE_EMAIL_TEMPLATE_ID = 140;

export const KANZI_SUPPORT_EMAIL_ADDRESS = 'support@kanzi.io';
